import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useState, useRef } from "react";
import { BsArrowRight } from "react-icons/bs";
import {
  TextField, MenuItem, Select, FormControl, InputLabel,
  Button, Typography, Box, Snackbar,
  Alert, Backdrop, Container,
  CircularProgress, Grid,
} from "@mui/material";
import { vendorApi } from "../../api/api";
import { useNavigate } from "react-router-dom";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const EditPropertyBody = () => {
  const location = useLocation();
  const { PropertyId, PropertyName,   Description , ProjectName, Address, City, percentagevalue,
    sqftamount, SizeInSqFt, UnitPrice, IconUrl, Status,videos = [], } = location.state || {}; // Extract passed data
  const [propertyName, setPropertyName] = useState(PropertyName || ''); // Initialize with passed data
  const [addressValue, setaddressValue] = useState(Address || '');
  const [cityValue, setCityValue] = useState(City || '');
  const [sizeinSqFt, setSizeinSqFt] = useState(SizeInSqFt || '');
  const [unitprice, setunitPrice] = useState(UnitPrice);
  const [selectedImage, setSelectedImage] = useState(IconUrl);
  const [iconUrl, setIconUrl] = useState(null);
  const [propertyErrors, setPropertyErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [statusValue, setStatusValue] = useState(Status || "Sale Initiated");
const [description, setDescription] = useState("");


  const [priceMode, setPriceMode] = useState("");
  const [extraValue, setExtraValue] = useState("");
  const [percentageVal, setPercentageVal] = useState(percentagevalue ?? "");
  const [sqftVal, setSqftVal] = useState(sqftamount ?? "");
  const [youtubeLinks, setYoutubeLinks] = useState([""]);
  

   /* ---------------- QUILL CONFIG ---------------- */
  const quillModules = {
    toolbar: [
      [{ header: [1, 2, false] }],
      ["bold", "italic", "underline"],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link"],
      ["clean"],
    ],
  };

  const quillFormats = [
    "header",
    "bold",
    "italic",
    "underline",
    "list",
    "bullet",
    "link",
  ];

   const getYoutubeEmbedUrl = (url) => {
  const match = url.match(
    /(?:youtube\.com\/watch\?v=|youtu\.be\/)([^&]+)/
  );
  return match ? `https://www.youtube.com/embed/${match[1]}` : null;
};

  const navigate = useNavigate();

  const handleSnackbarClose = () => setSnackbarOpen(false);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    if (name === 'propertyName') {
      setPropertyName(value);
    } else if (name === 'City') {
      setCityValue(value);
    } else if (name === 'addressValue') {
      setaddressValue(value);
    } else if (name === 'sizeinSqFt') {
      setSizeinSqFt(value);
    } else if (name === 'unitprice') {
      setunitPrice(value);
    } else if (name === "status") {
      setStatusValue(value);
    }


  };

  const validate = () => {
    let isValid = true;


    if (!propertyName || propertyName.trim() === '') {
      alert('Property Name field is required.');
      isValid = false;
    }
    // if (!projectName || projectName.trim() === '') {
    //   alert('Project Name field is required.');
    //   isValid = false;
    // }
    if (!addressValue || addressValue.trim() === '') {
      alert('Address field is required.');
      isValid = false;
    } if (!cityValue || cityValue.trim() === '') {
      alert('City field is required.');
      isValid = false;
    } if (!sizeinSqFt) {
      alert('SizeinSqFt field is required.');
      isValid = false;
    } if (!unitprice || unitprice.trim() === '') {
      alert('Unit Price field is required.');
      isValid = false;
    }
    // if (!investmenttype || investmenttype.trim() === '') {
    //   alert('Investment Type field is required.');
    //   isValid = false;
    // }

    return isValid;
  };





  useEffect(() => {
    const hasPercentage =
      percentagevalue !== null &&
      percentagevalue !== undefined &&
      percentagevalue !== "";

    const hasSqft =
      sqftamount !== null &&
      sqftamount !== undefined &&
      sqftamount !== "";

    if (hasPercentage) {
      setPriceMode("percentage");
      setExtraValue(percentagevalue);
    } else if (hasSqft) {
      setPriceMode("sqft");
      setExtraValue(sqftamount);
    } else {
      setPriceMode("");
      setExtraValue("");
    }
  }, [percentagevalue, sqftamount]);


  useEffect(() => {
    if (percentagevalue != null && percentagevalue !== "") {
      setPriceMode("percentage");
    } else if (sqftamount != null && sqftamount !== "") {
      setPriceMode("sqft");
    }
  }, []);

  useEffect(() => {
  if (Description) {
    setDescription(Description);
  }
}, [Description]);


useEffect(() => {
  if (videos.length > 0) {
    setYoutubeLinks(videos);
  }
}, [videos]);
  const handlePriceModeChange = (event) => {
    const mode = event.target.value;
    setPriceMode(mode);

    if (mode === "percentage") {
      setSqftVal("");     // clear sqft
    } else {
      setPercentageVal(""); // clear percentage
    }
  };

  const handleDisplayImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      // Extract the file name from the selected file
      const displayImageName = file.name; // Get the file name, e.g., "add1.png"
      setSelectedImage(URL.createObjectURL(file)); // Set preview
      setIconUrl(file); // Store only the name, not the full URL
    }
  };

  const saveProperty = async (event) => {
    event.preventDefault();

    if (!validate()) return;

    const formData = new FormData();
    formData.append("Status", statusValue);

    formData.append("id", PropertyId);
    formData.append("PropertyName", propertyName);
    formData.append("City", cityValue);
    formData.append("Address", addressValue);
    formData.append("SizeInSqFt", sizeinSqFt);
    formData.append("SqFtPrice", unitprice); // Note: match the backend key exactly!
formData.append("Description", description); // ✅ ADD

    // 🔑 price type logic
    if (priceMode === "percentage") {
      formData.append("percentagevalue", percentageVal);
      formData.append("sqftamount", ""); // or null if backend accepts
    }

    if (priceMode === "sqft") {
      formData.append("sqftamount", sqftVal);
      formData.append("percentagevalue", "");
    }

    if (iconUrl) {
      formData.append("iconUrl", iconUrl); 
    }

    formData.append(
  "youtube_links",
  JSON.stringify(youtubeLinks.filter(link => link.trim() !== ""))
);

    try {
      setLoading(true);
      for (let [key, value] of formData.entries()) {
        console.log(key, value);
      } 

      const response = await vendorApi.editProperty(formData);
      if (response.status == 200) {
        setSnackbarMessage("Property edited successfully!");
        setSnackbarSeverity("success");
        setSnackbarOpen(true);
        setTimeout(() => {
          navigate("/property");
        }, 2000);
      }

    } catch (error) {
      console.error("Error editing property", error);
      setSnackbarMessage(error?.response?.data?.error || "Failed to edit property.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    } finally {
      setLoading(false);
    }
  };

  const editCancelProperty = () => {
    window.location.href = "/property";  // Redirect to the properties list
  };

  return (
    <Container sx={{ py: 5, maxWidth: "80%" }}>
      {/* Loader */}
      <Backdrop open={loading} sx={{ zIndex: 1300, color: "#fff" }}>
        <CircularProgress color="inherit" />
      </Backdrop>

      {/* Snackbar */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>

      <Box
        sx={{
          margin: "2rem auto",
          padding: "2rem",
          borderRadius: "10px",
          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
          backgroundColor: "#fff",
          maxWidth: '80%',
        }}
      >
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 4 }}>
          <Typography variant="h4" component="h1" sx={{ color: '#13216e', fontWeight: 600, fontSize: '24px' }}>
            Edit Property
          </Typography>
          <Box>
            <Link to="/property/propertyList" style={{ textDecoration: "none", color: '#4e0dff', fontSize: '18px' }}>
              Home
            </Link>
            <BsArrowRight style={{ margin: "-2px 8px", color: "#4e0dff" }} />
            <Link to="#" style={{ textDecoration: "none", color: "#4e0dff", fontSize: '18px' }}>
              Property
            </Link>
          </Box>
        </Box>


        <Grid container spacing={2} style={{ marginTop: '10px' }}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Property Name"
              variant="outlined"
              name="propertyName"
              value={propertyName}
              onChange={handleInputChange}
              required
            />
          </Grid>


          <Grid item xs={12}>
            <TextField
              fullWidth
              type="text"
              label="City"
              variant="outlined"
              name="city"
              value={cityValue}
              onChange={handleInputChange}
              required
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              type="text"
              label="Address"
              variant="outlined"
              name="address"
              value={addressValue}
              onChange={handleInputChange}
              required
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              type="number"
              label="Size in SqFt"
              variant="outlined"
              name="sizeinSqFt"
              value={sizeinSqFt}
              onChange={handleInputChange}
              required
            />
          </Grid>

          <Grid item xs={12}>
            <FormControl fullWidth>
              <InputLabel id="status-label">Status</InputLabel>
              <Select
                labelId="status-label"
                label="Status"
                name="status"
                value={statusValue}
                onChange={handleInputChange}
              >
                <MenuItem value="Sale Initiated">Sale Initiated</MenuItem>
                <MenuItem value="Approved">Approved</MenuItem>
                <MenuItem value="Sold">Sold</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth>
              <InputLabel>Price Type</InputLabel>
              <Select
                value={priceMode}
                label="Price Type"
                onChange={handlePriceModeChange}
              >
                <MenuItem value="percentage">Percentage (%)</MenuItem>
                <MenuItem value="sqft">Sqft Amount</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          {priceMode === "percentage" && (
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Percentage Value"
                value={percentageVal}
                onChange={(e) => setPercentageVal(e.target.value)}
              />
            </Grid>
          )}

          {priceMode === "sqft" && (
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Sqft Amount"
                value={sqftVal}
                onChange={(e) => setSqftVal(e.target.value)}
              />
            </Grid>
          )}
 <Grid item xs={12}>
              <Typography fontWeight={600}>Property Description</Typography>
              <ReactQuill
                value={description}
                onChange={setDescription}
                modules={quillModules}
                formats={quillFormats}
                style={{ height: 200, marginBottom: 40 }}
              />
            </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              disabled
              type="text"
              label="Unit Price"
              variant="outlined"
              name="unitprice"
              value={unitprice}
              onChange={handleInputChange}
              required
            />
          </Grid>



          <Grid item xs={12}>
            <Typography variant="h6" sx={{ color: "#13216e", fontWeight: 600, fontSize: "20px" }}>Display Picture</Typography>

            {/* Custom Button for Display Image */}
            <label htmlFor="display-image-upload" style={{ cursor: "pointer", margin: '10px 15px' }}>
              <Button
                variant="outlined"
                color="primary"
                component="span"
                sx={{
                  borderColor: 'primary.main', // Adjust color here
                  color: '#fff', // Button text color
                  backgroundColor: '#1565c0', // Hover effect
                  '&:hover': {
                    background: '#1565c0',
                    color: 'rgba(25, 118, 210, 0.04)',
                    borderColor: '#1976d2',
                    outlined: ' rgba(25, 118, 210, 0.04)',
                  }
                }}
              >
                Choose Display Image
              </Button>
            </label>

            <input
              id="display-image-upload"
              type="file"
              onChange={handleDisplayImageChange}
              style={{ display: 'none' }} // Hide the default file input
            />

            {selectedImage && (
              <Box sx={{ mt: 2 }}>
                <img
                  src={selectedImage}
                  alt="Display"
                  style={{
                    width: '20%',
                    height: '20%',
                    objectFit: "cover",
                    margin: 5,
                    borderRadius: 8,
                  }}
                />
              </Box>
            )}
            {propertyErrors.displayImage && (
              <Typography color="error">{propertyErrors.displayImage}</Typography>
            )}
          </Grid>
          <Grid item xs={12}>
            <Typography
              variant="h6"
              sx={{ color: "#13216e", fontWeight: 600, fontSize: "20px" }}
            >
              Property Videos (YouTube URL)
            </Typography>
            
            
          
            {youtubeLinks.map((link, index) => (
              <Box key={index} sx={{ display: "flex", gap: 2, mt: 1 }}>
                <TextField
    key={index}
    label={`YouTube Link ${index + 1}`}
    fullWidth
    margin="normal"
    value={link}
    onChange={(e) => {
      const updated = [...youtubeLinks];
      updated[index] = e.target.value;
      setYoutubeLinks(updated);
    }}
  />
          
                {youtubeLinks.length > 1 && (
                  <Button
                    color="error"
                    onClick={() =>
                      setYoutubeLinks(youtubeLinks.filter((_, i) => i !== index))
                    }
                  >
                    Remove
                  </Button>
                )}
              </Box>
            ))}
          
            <Button sx={{ mt: 2 }} onClick={() => setYoutubeLinks([...youtubeLinks, ""])}>
              + Add Another Video
            </Button>
          
          <Grid container spacing={2} sx={{ mt: 2 }}>
            {youtubeLinks.map((link, index) => {
              const embedUrl = getYoutubeEmbedUrl(link);
              if (!embedUrl) return null;
          
              return (
                <Grid item xs={12} sm={6} md={4} key={index}>
                  <Box
                    sx={{
                      borderRadius: 2,
                      overflow: "hidden",
                      boxShadow: 2,
                    }}
                  >
                    <iframe
                      src={embedUrl}
                      width="100%"
                      height="200"
                      style={{ border: "none" }}
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                      title={`youtube-${index}`}
                    />
                  </Box>
                </Grid>
              );
            })}
          </Grid>
          </Grid>
          <Grid item xs={12} sx={{ display: "flex", justifyContent: "flex-end", gap: 2, mt: 2 }}>
            <Button variant="contained" color="primary" onClick={saveProperty} disabled={loading}>
              {loading ? "Saving..." : "Save"}
            </Button>
            <Button variant="outlined" color="secondary" onClick={editCancelProperty}>
              Cancel
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
};

export default EditPropertyBody;